export default __webpack_public_path__ + "static/media/discord.46ef476e.svg";